module.exports = __webpack_public_path__ + "fonts/Roboto-Black.a77b7fc.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Roboto/Roboto-Black.ttf
// module id = 174
// module chunks = 245 246